import { render, staticRenderFns } from "./SiteFooterComponent.vue?vue&type=template&id=b57563b2"
import script from "./SiteFooterComponent.vue?vue&type=script&lang=js"
export * from "./SiteFooterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports